<div class="card-slider flex-r align-center gap-16">
  <div class="cards" #scrl (scroll)="scrollCheck()">
    @if (isLoading) {
      @for (item of [].constructor(4); track $index) {
        <p-skeleton
          class="skeleton-desktop"
          width="288px"
          height="88px"
          borderRadius="16px" />
        <p-skeleton
          class="skeleton-mobile"
          width="120px"
          height="28px"
          borderRadius="8px" />
      }
    } @else {
      @for (slide of slides; track slide.title) {
        <app-card-header-navigation
          [card]="slide"
          (onCardClick)="onCardClick(slide)"></app-card-header-navigation>
      }
    }
    <div (click)="slide(-300)" class="leftArrow cursor-pointer circle-large">
      <div class="circle-icon">
        <i class="fa-regular fa-chevron-left fa-xs"></i>
      </div>
    </div>
    <div (click)="slide(300)" class="rightArrow cursor-pointer circle-large">
      <div class="circle-icon">
        <i class="fa-regular fa-chevron-right fa-xs"></i>
      </div>
    </div>
  </div>
</div>
